import { storeIndex } from './init';

import { AlgoliaStore } from '~/types/store/store';

export default async function getStores(storesId: Array<string>) {
  return storeIndex.getObjects<AlgoliaStore>(storesId);
}
